import { createSelector } from 'reselect';
import { selectFeatureFlags } from 'yoda-site-components/lib/selectors/ContextSelector';

const getVtoParameters = (state) => state.virtualTryOn || {};

export const getVirtualTryOnData = createSelector(
    [selectFeatureFlags, getVtoParameters],
    (featureFlags, vtoParameters) => {
        const vtoEligibilityForPP =
            featureFlags.enablePDPVirtualTryOn && vtoParameters.vtoAvailabilityForPP;
        return {
            vtoEligibilityForPP,
            data: vtoParameters,
        };
    }
);

export default getVirtualTryOnData;
